module.exports = __webpack_public_path__ + "img/main_media_slide9.6ef79786.jpg";